var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("dd-header"),
      _vm._v(" "),
      !_vm.isConfirm
        ? [
            _c("div", { staticClass: "title" }, [
              _c("img", {
                attrs: {
                  src: _vm.getImage("sketchorder_banner_01.gif"),
                  alt: "SKETCH ORDER"
                }
              })
            ]),
            _vm._v(" "),
            _c("article", { staticClass: "overview" }, [
              _c("section", { attrs: { id: "about" } }, [
                _c(
                  "div",
                  {
                    staticClass: "frame_by_frame",
                    attrs: { id: "about_list" }
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: _vm.getImage("sketchorder_banner_02.gif"),
                        alt: "スケッチオーダーとは"
                      },
                      on: { click: _vm.onSketchUpload }
                    }),
                    _vm._v(" "),
                    _c("p", { attrs: { "data-nosnippet": "" } }, [
                      _vm._v(
                        "\n            あなたの理想のイメージをスケッチしてアップロードすれば、オーダー家具の専門家が図面と見積書を作成して貴方だけの収納をご提案をします！\n          "
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("section", { attrs: { id: "plan_list" } }, [
                _c("h3", { attrs: { "data-nosnippet": "" } }, [
                  _vm._v("自分が考えた、壁から壁までピッタリの収納！")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "case_study_plan" }, [
                  _c("picture", [
                    _c("source", {
                      attrs: {
                        srcset: _vm.getImage("paln_photo/photo_all.png"),
                        type: "image/png",
                        media: "(min-width: 960px)"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: _vm.getImage("paln_photo/photo_all_sp.png"),
                        type: "image/png",
                        alt: "事例＆デザインプラン"
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _c("article", { ref: "refRequestType", staticClass: "overview" }, [
              _c("section", { attrs: { id: "selectedRequestType" } }, [
                _c("h3", [_vm._v("ご希望のお問合せ方式をご選択ください")]),
                _vm._v(" "),
                _c("div", { staticClass: "order_select" }, [
                  _c(
                    "div",
                    {
                      class: { selected: _vm.requestType === 1 },
                      on: {
                        click: function($event) {
                          _vm.onRequestType(1)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img_list",
                        attrs: { src: _vm.getImage("common/talk.svg"), alt: "" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("打ち合わせ")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { selected: _vm.requestType === 2 },
                      on: {
                        click: function($event) {
                          _vm.onRequestType(2)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img_list",
                        attrs: { src: _vm.getImage("common/file.svg"), alt: "" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("見積もり")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { selected: _vm.requestType === 3 },
                      on: {
                        click: function($event) {
                          _vm.onRequestType(3)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img_list",
                        attrs: {
                          src: _vm.getImage("common/pallet.svg"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(2)
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "article",
              { ref: "refUpload", attrs: { id: "sketch_upload" } },
              [
                _vm.requestType == 3
                  ? _c("section", { staticClass: "overview" }, [
                      _c("h2", { staticClass: "upload_icon" }, [
                        _vm._v("スケッチアップロード")
                      ]),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "enable_action",
                          on: { click: _vm.onEnableAct }
                        },
                        [_vm._v("スケッチのアップロード手順はこちら")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isAction,
                              expression: "isAction"
                            }
                          ],
                          staticClass: "upload_action"
                        },
                        [
                          _c("ul", [
                            _c("li", [
                              _c("div", [_vm._v("1.画像を追加をタップする")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img_list",
                                attrs: {
                                  src: _vm.getImage(
                                    "action/phone/sketchupload_sp01.webp"
                                  ),
                                  alt: "スケッチアップロード手順1"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", [_vm._v("2.写真ライブラリを選択する")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img_list",
                                attrs: {
                                  src: _vm.getImage(
                                    "action/phone/sketchupload_sp02.webp"
                                  ),
                                  alt: "スケッチアップロード手順2"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", [
                                _vm._v("3.一覧から写真で撮った図面を選択する")
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img_list",
                                attrs: {
                                  src: _vm.getImage(
                                    "action/phone/sketchupload_sp03.webp"
                                  ),
                                  alt: "スケッチアップロード手順3"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", [
                                _vm._v("4.写真を確認し選択をタップする")
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img_list",
                                attrs: {
                                  src: _vm.getImage(
                                    "action/phone/sketchupload_sp04.webp"
                                  ),
                                  alt: "スケッチアップロード手順4"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", [
                                _vm._v("5.選択したスケッチが追加されます")
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img_list",
                                attrs: {
                                  src: _vm.getImage(
                                    "action/phone/sketchupload_sp05.webp"
                                  ),
                                  alt: "スケッチアップロード手順5"
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType == 3
                  ? _c(
                      "section",
                      { ref: "refUpload", staticClass: "upload_form" },
                      [
                        _c("h3", { staticClass: "h3_color" }, [
                          _vm._v("撮影したスケッチ画像をアップロードする")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "アップロードするスケッチ画像を追加してください。"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "sketch_list" },
                          [
                            _vm._l(_vm.inputForm.upImgList, function(
                              image,
                              index
                            ) {
                              return _c("li", { key: "upimage-" + index }, [
                                _c("img", { attrs: { src: image.thumnail } }),
                                _c("a", {
                                  staticClass: "close_sketch",
                                  on: {
                                    click: function($event) {
                                      _vm.removeImage(index)
                                    }
                                  }
                                })
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.inputForm.upImgList.length < 10,
                                    expression:
                                      "inputForm.upImgList.length < 10"
                                  }
                                ],
                                attrs: { id: "add_sketch" },
                                on: { click: _vm.onAddSketch }
                              },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0);" } },
                                  [_vm._v("画像を追加")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  ref: "newFileRef",
                                  attrs: { type: "file" },
                                  on: { change: _vm.onFileChange }
                                })
                              ]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.errors.maxImg
                          ? _c("div", { staticClass: "error_text2" }, [
                              _vm._v(_vm._s(_vm.errors.maxImg))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", { staticClass: "wide" }, [
                            _vm._v("スケッチの補足、ご要望など")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.comment,
                                expression: "inputForm.comment"
                              }
                            ],
                            attrs: {
                              name: "comment",
                              maxlength: "500",
                              placeholder:
                                "スケッチでは表現できないご要望をお書きください。※最大500文字"
                            },
                            domProps: { value: _vm.inputForm.comment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "comment",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType == 3
                  ? _c("section", { staticClass: "upload_form" }, [
                      _c("h3", { staticClass: "h3_normal" }, [
                        _vm._v("連絡先等")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_elements elements_required" },
                        [
                          _c("label", [_vm._v("メールアドレス")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.email,
                                expression: "inputForm.email",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "mail",
                              placeholder: "sketchorder@domans.co.jp"
                            },
                            domProps: { value: _vm.inputForm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "email",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.email
                            ? _c("div", { staticClass: "error_text" }, [
                                _vm._v(_vm._s(_vm.errors.email))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_elements elements_required" },
                        [
                          _c("label", [_vm._v("氏")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.lastName,
                                expression: "inputForm.lastName",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "name_1",
                              maxlength: "32",
                              placeholder: "家具"
                            },
                            domProps: { value: _vm.inputForm.lastName },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "lastName",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("名")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.firstName,
                                expression: "inputForm.firstName",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "name_2",
                              maxlength: "32",
                              placeholder: "太郎"
                            },
                            domProps: { value: _vm.inputForm.firstName },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "firstName",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.name
                            ? _c("div", { staticClass: "error_text" }, [
                                _vm._v(_vm._s(_vm.errors.name))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_elements elements_required" },
                        [
                          _c("label", [_vm._v("氏（カナ）")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.lastNameKana,
                                expression: "inputForm.lastNameKana",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "name_kana1",
                              maxlength: "32",
                              placeholder: "カグ"
                            },
                            domProps: { value: _vm.inputForm.lastNameKana },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "lastNameKana",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("名（カナ）")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.firstNameKana,
                                expression: "inputForm.firstNameKana",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "name_kana2",
                              maxlength: "32",
                              placeholder: "タロウ"
                            },
                            domProps: { value: _vm.inputForm.firstNameKana },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "firstNameKana",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.nameKana
                            ? _c("div", { staticClass: "error_text" }, [
                                _vm._v(_vm._s(_vm.errors.nameKana))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_elements elements_required" },
                        [
                          _c("label", [_vm._v("お届け先の郵便番号")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.postcd,
                                expression: "inputForm.postcd",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "postal_code",
                              oninput:
                                "if(value.length>7)value=value.slice(0,7)",
                              placeholder:
                                "1510053 ※配送料の計算に使用されます。"
                            },
                            domProps: { value: _vm.inputForm.postcd },
                            on: {
                              keypress: _vm.validateNumber,
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "postcd",
                                    $event.target.value.trim()
                                  )
                                },
                                function($event) {
                                  _vm.inputForm.postcd = _vm.inputRestNumber(
                                    $event
                                  )
                                }
                              ],
                              blur: [
                                _vm.addressCompletion,
                                function($event) {
                                  _vm.$forceUpdate()
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.postcd
                            ? _c("div", { staticClass: "error_text" }, [
                                _vm._v(_vm._s(_vm.errors.postcd))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form_elements" }, [
                        _c("label", [_vm._v("住所")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputForm.address,
                              expression: "inputForm.address"
                            }
                          ],
                          attrs: { type: "text", name: "address" },
                          domProps: { value: _vm.inputForm.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputForm,
                                "address",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form_elements" }, [
                        _c("label", [_vm._v("番地/建物名")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputForm.streetBuilding,
                              expression: "inputForm.streetBuilding"
                            }
                          ],
                          attrs: { type: "text", name: "streetBuilding" },
                          domProps: { value: _vm.inputForm.streetBuilding },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputForm,
                                "streetBuilding",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_elements elements_required" },
                        [
                          _c("label", [_vm._v("連絡先電話番号")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.inputForm.tel,
                                expression: "inputForm.tel",
                                modifiers: { trim: true }
                              }
                            ],
                            attrs: {
                              type: "text",
                              name: "phone",
                              oninput:
                                "if(value.length>11)value=value.slice(0,11)",
                              placeholder: "09011112222"
                            },
                            domProps: { value: _vm.inputForm.tel },
                            on: {
                              keypress: _vm.validateNumber,
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "tel",
                                    $event.target.value.trim()
                                  )
                                },
                                function($event) {
                                  _vm.inputForm.tel = _vm.inputRestNumber(
                                    $event
                                  )
                                }
                              ],
                              blur: function($event) {
                                _vm.$forceUpdate()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.tel
                            ? _c("div", { staticClass: "error_text" }, [
                                _vm._v(_vm._s(_vm.errors.tel))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form_elements elements_required" },
                        [
                          _c("label", [_vm._v("設置場所について")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.inputForm.location,
                                  expression: "inputForm.location",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: { name: "location" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return _vm._n(val)
                                    })
                                  _vm.$set(
                                    _vm.inputForm,
                                    "location",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("--選択してください--")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "1" } }, [
                                _vm._v("集合住宅(1階)")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "2" } }, [
                                _vm._v("集合住宅(２階以上)")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "3" } }, [
                                _vm._v("一戸建て住宅(1階)")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "4" } }, [
                                _vm._v("一戸建て住宅(２階以上)")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "5" } }, [
                                _vm._v("その他")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.location
                            ? _c("div", { staticClass: "error_text" }, [
                                _vm._v(_vm._s(_vm.errors.location))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "cb" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputForm.elevetorFlg,
                                  expression: "inputForm.elevetorFlg"
                                }
                              ],
                              attrs: {
                                id: "elevator",
                                type: "checkbox",
                                name: "elevator"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.inputForm.elevetorFlg
                                )
                                  ? _vm._i(_vm.inputForm.elevetorFlg, null) > -1
                                  : _vm.inputForm.elevetorFlg
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.inputForm.elevetorFlg,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.inputForm,
                                          "elevetorFlg",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.inputForm,
                                          "elevetorFlg",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.inputForm, "elevetorFlg", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v("エレベーター有り\n          ")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType == 1
                  ? _c(
                      "section",
                      { staticClass: "upload_form", attrs: { id: "meeting" } },
                      [
                        _c("h3", { staticClass: "h3_normal" }, [
                          _vm._v("ご希望内容")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "radio",
                            attrs: { id: "meeting_btn" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.categoryPref,
                                  expression: "categoryPref",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: {
                                type: "radio",
                                name: "meeting_radio",
                                id: "support_pref",
                                value: "1"
                              },
                              domProps: {
                                checked: _vm._q(_vm.categoryPref, _vm._n("1"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.categoryPref = _vm._n("1")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "support_pref" } }, [
                              _vm._v("お問合せ希望")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.categoryPref,
                                  expression: "categoryPref",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: {
                                type: "radio",
                                name: "meeting_radio",
                                id: "meeting_pref_zoom",
                                checked: "",
                                value: "2"
                              },
                              domProps: {
                                checked: _vm._q(_vm.categoryPref, _vm._n("2"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.categoryPref = _vm._n("2")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "meeting_pref_zoom" } },
                              [_vm._v("お打ち合わせ希望(ZOOM)")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.categoryPref,
                                  expression: "categoryPref",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: {
                                type: "radio",
                                name: "meeting_radio",
                                id: "meeting_pref_corp",
                                checked: "",
                                value: "3"
                              },
                              domProps: {
                                checked: _vm._q(_vm.categoryPref, _vm._n("3"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.categoryPref = _vm._n("3")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "meeting_pref_corp" } },
                              [_vm._v("お打ち合わせ希望（弊社ショールーム）")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("氏")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.lastName,
                                  expression: "inputForm.lastName",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_1",
                                maxlength: "32",
                                placeholder: "家具"
                              },
                              domProps: { value: _vm.inputForm.lastName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "lastName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("名")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.firstName,
                                  expression: "inputForm.firstName",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_2",
                                maxlength: "32",
                                placeholder: "太郎"
                              },
                              domProps: { value: _vm.inputForm.firstName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "firstName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.name
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.name))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("氏（カナ）")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.lastNameKana,
                                  expression: "inputForm.lastNameKana",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_kana1",
                                maxlength: "32",
                                placeholder: "カグ"
                              },
                              domProps: { value: _vm.inputForm.lastNameKana },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "lastNameKana",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("名（カナ）")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.firstNameKana,
                                  expression: "inputForm.firstNameKana",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_kana2",
                                maxlength: "32",
                                placeholder: "タロウ"
                              },
                              domProps: { value: _vm.inputForm.firstNameKana },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "firstNameKana",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.nameKana
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.nameKana))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", { staticClass: "wide" }, [
                            _vm._v("お問合せ内容")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.comment,
                                expression: "inputForm.comment"
                              }
                            ],
                            attrs: {
                              name: "comment",
                              maxlength: "500",
                              placeholder:
                                "お問合せ/お打ち合わせの内容を自由に入力してください"
                            },
                            domProps: { value: _vm.inputForm.comment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "comment",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("第一希望日")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.prefData1,
                                expression: "inputForm.prefData1"
                              }
                            ],
                            attrs: { type: "text", name: "pref_date_1st" },
                            domProps: { value: _vm.inputForm.prefData1 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "prefData1",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("第二希望日")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.prefData2,
                                expression: "inputForm.prefData2"
                              }
                            ],
                            attrs: { type: "text", name: "pref_date_2nd" },
                            domProps: { value: _vm.inputForm.prefData2 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "prefData2",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("第三希望日")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.prefData3,
                                expression: "inputForm.prefData3"
                              }
                            ],
                            attrs: { type: "text", name: "pref_date_3rd" },
                            domProps: { value: _vm.inputForm.prefData3 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "prefData3",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "elements_checkbox" }, [
                          _c("div", [
                            _vm._v("本サイトをどちらでお知りになりましたか？")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cb" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.instagram,
                                  expression: "infoSrc.instagram"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_insta" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.instagram)
                                  ? _vm._i(_vm.infoSrc.instagram, null) > -1
                                  : _vm.infoSrc.instagram
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.instagram,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "instagram",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "instagram",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "instagram", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_insta" } }, [
                              _vm._v("instagram")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.internet,
                                  expression: "infoSrc.internet"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_internet" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.internet)
                                  ? _vm._i(_vm.infoSrc.internet, null) > -1
                                  : _vm.infoSrc.internet
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.internet,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "internet",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "internet",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "internet", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_internet" } }, [
                              _vm._v("インターネット検索")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.introduce,
                                  expression: "infoSrc.introduce"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_introduce" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.introduce)
                                  ? _vm._i(_vm.infoSrc.introduce, null) > -1
                                  : _vm.infoSrc.introduce
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.introduce,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "introduce",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "introduce",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "introduce", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_introduce" } }, [
                              _vm._v("ご紹介")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.advert,
                                  expression: "infoSrc.advert"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_advert" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.advert)
                                  ? _vm._i(_vm.infoSrc.advert, null) > -1
                                  : _vm.infoSrc.advert
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.advert,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "advert",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "advert",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "advert", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_advert" } }, [
                              _vm._v("広告")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.other,
                                  expression: "infoSrc.other"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_other" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.other)
                                  ? _vm._i(_vm.infoSrc.other, null) > -1
                                  : _vm.infoSrc.other
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.other,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "other",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "other",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "other", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_other" } }, [
                              _vm._v("その他")
                            ])
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType == 2
                  ? _c(
                      "section",
                      { staticClass: "upload_form", attrs: { id: "estimate" } },
                      [
                        _c("h3", { staticClass: "h3_normal" }, [
                          _vm._v("お客様情報")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("氏")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.lastName,
                                  expression: "inputForm.lastName",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_1",
                                maxlength: "32",
                                placeholder: "家具"
                              },
                              domProps: { value: _vm.inputForm.lastName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "lastName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("名")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.firstName,
                                  expression: "inputForm.firstName",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_2",
                                maxlength: "32",
                                placeholder: "太郎"
                              },
                              domProps: { value: _vm.inputForm.firstName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "firstName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.name
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.name))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("氏（カナ）")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.lastNameKana,
                                  expression: "inputForm.lastNameKana",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_1",
                                maxlength: "32",
                                placeholder: "カグ"
                              },
                              domProps: { value: _vm.inputForm.lastNameKana },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "lastNameKana",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("名（カナ）")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.firstNameKana,
                                  expression: "inputForm.firstNameKana",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "name_2",
                                maxlength: "32",
                                placeholder: "タロウ"
                              },
                              domProps: { value: _vm.inputForm.firstNameKana },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputForm,
                                    "firstNameKana",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.nameKana
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.nameKana))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("お届け先の郵便番号")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.postcd,
                                  expression: "inputForm.postcd",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "postal_code",
                                oninput:
                                  "if(value.length>7)value=value.slice(0,7)",
                                placeholder:
                                  "1510053 ※配送料の計算に使用されます。"
                              },
                              domProps: { value: _vm.inputForm.postcd },
                              on: {
                                keypress: _vm.validateNumber,
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.inputForm,
                                      "postcd",
                                      $event.target.value.trim()
                                    )
                                  },
                                  function($event) {
                                    _vm.inputForm.postcd = _vm.inputRestNumber(
                                      $event
                                    )
                                  }
                                ],
                                blur: [
                                  _vm.addressCompletion,
                                  function($event) {
                                    _vm.$forceUpdate()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.postcd
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.postcd))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("現住所")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.address,
                                expression: "inputForm.address"
                              }
                            ],
                            attrs: { type: "text", name: "address" },
                            domProps: { value: _vm.inputForm.address },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "address",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("番地/建物名")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.streetBuilding,
                                expression: "inputForm.streetBuilding"
                              }
                            ],
                            attrs: { type: "text", name: "streetBuilding" },
                            domProps: { value: _vm.inputForm.streetBuilding },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "streetBuilding",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("メールアドレス")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.email,
                                expression: "inputForm.email"
                              }
                            ],
                            attrs: { type: "text", name: "email" },
                            domProps: { value: _vm.inputForm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "email",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("電話番号")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.tel,
                                expression: "inputForm.tel"
                              }
                            ],
                            attrs: { type: "text", name: "tel" },
                            domProps: { value: _vm.inputForm.tel },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "tel",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType == 2
                  ? _c(
                      "section",
                      {
                        staticClass: "upload_form",
                        attrs: { id: "deliveryBudget" }
                      },
                      [
                        _c("h3", { staticClass: "h3_normal" }, [
                          _vm._v("納品先情報・ご予算")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("納品先郵便番号")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.inputForm.deliPostcd,
                                  expression: "inputForm.deliPostcd",
                                  modifiers: { trim: true }
                                }
                              ],
                              attrs: {
                                type: "text",
                                name: "postal_code",
                                oninput:
                                  "if(value.length>7)value=value.slice(0,7)",
                                placeholder:
                                  "1510053 ※配送料の計算に使用されます。"
                              },
                              domProps: { value: _vm.inputForm.deliPostcd },
                              on: {
                                keypress: _vm.validateNumber,
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.inputForm,
                                      "deliPostcd",
                                      $event.target.value.trim()
                                    )
                                  },
                                  function($event) {
                                    _vm.inputForm.deliPostcd = _vm.inputRestNumber(
                                      $event
                                    )
                                  }
                                ],
                                blur: [
                                  _vm.addressCompletion,
                                  function($event) {
                                    _vm.$forceUpdate()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.deliPostcd
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.deliPostcd))
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("納品先住所")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.deliAddress,
                                expression: "inputForm.deliAddress"
                              }
                            ],
                            attrs: { type: "text", name: "address" },
                            domProps: { value: _vm.inputForm.deliAddress },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "deliAddress",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("番地/建物名")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.deliStreetBuilding,
                                expression: "inputForm.deliStreetBuilding"
                              }
                            ],
                            attrs: { type: "text", name: "streetBuilding" },
                            domProps: {
                              value: _vm.inputForm.deliStreetBuilding
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "deliStreetBuilding",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form_elements elements_required" },
                          [
                            _c("label", [_vm._v("設置場所について")]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.inputForm.location,
                                    expression: "inputForm.location",
                                    modifiers: { number: true }
                                  }
                                ],
                                attrs: { name: "location" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return _vm._n(val)
                                      })
                                    _vm.$set(
                                      _vm.inputForm,
                                      "location",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("--選択してください--")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("集合住宅(1階)")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("集合住宅(２階以上)")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "3" } }, [
                                  _vm._v("一戸建て住宅(1階)")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "4" } }, [
                                  _vm._v("一戸建て住宅(２階以上)")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "5" } }, [
                                  _vm._v("その他")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.location
                              ? _c("div", { staticClass: "error_text" }, [
                                  _vm._v(_vm._s(_vm.errors.location))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "cb" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.inputForm.elevetorFlg,
                                    expression: "inputForm.elevetorFlg"
                                  }
                                ],
                                attrs: {
                                  id: "elevator",
                                  type: "checkbox",
                                  name: "elevator"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.inputForm.elevetorFlg
                                  )
                                    ? _vm._i(_vm.inputForm.elevetorFlg, null) >
                                      -1
                                    : _vm.inputForm.elevetorFlg
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.inputForm.elevetorFlg,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.inputForm,
                                            "elevetorFlg",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.inputForm,
                                            "elevetorFlg",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.inputForm,
                                        "elevetorFlg",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v("エレベーター有り\n          ")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("納品希望時期")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "radio" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.deliveryPref,
                                  expression: "deliveryPref",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: {
                                type: "radio",
                                name: "delivery_radio",
                                id: "delivery_fast",
                                value: "1"
                              },
                              domProps: {
                                checked: _vm._q(_vm.deliveryPref, _vm._n("1"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.deliveryPref = _vm._n("1")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "delivery_fast" } }, [
                              _vm._v("できるだけ早く")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.deliveryPref,
                                  expression: "deliveryPref",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: {
                                type: "radio",
                                name: "delivery_radio",
                                id: "delivery_decided",
                                checked: "",
                                value: "2"
                              },
                              domProps: {
                                checked: _vm._q(_vm.deliveryPref, _vm._n("2"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.deliveryPref = _vm._n("2")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "delivery_decided" } },
                              [_vm._v("まだ決めていない")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.deliveryPref,
                                  expression: "deliveryPref",
                                  modifiers: { number: true }
                                }
                              ],
                              attrs: {
                                type: "radio",
                                name: "delivery_radio",
                                id: "delivery_appoint",
                                checked: "",
                                value: "3"
                              },
                              domProps: {
                                checked: _vm._q(_vm.deliveryPref, _vm._n("3"))
                              },
                              on: {
                                change: function($event) {
                                  _vm.deliveryPref = _vm._n("3")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "delivery_appoint" } },
                              [_vm._v("指定したい")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("指定したい場合の希望時期")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.deliveryPrefText,
                                expression: "inputForm.deliveryPrefText"
                              }
                            ],
                            attrs: { type: "text", name: "deliveryPrefText" },
                            domProps: { value: _vm.inputForm.deliveryPrefText },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "deliveryPrefText",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("ご予算")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.deliAddress,
                                expression: "inputForm.deliAddress"
                              }
                            ],
                            attrs: { type: "text", name: "deliAddress" },
                            domProps: { value: _vm.inputForm.deliAddress },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "deliAddress",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType == 2
                  ? _c(
                      "section",
                      {
                        staticClass: "upload_form",
                        attrs: { id: "preference" }
                      },
                      [
                        _c("h3", { staticClass: "h3_normal" }, [
                          _vm._v("ご希望内容")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("ご検討中の家具")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.funitureType,
                                expression: "inputForm.funitureType"
                              }
                            ],
                            attrs: { type: "text", name: "funitureType" },
                            domProps: { value: _vm.inputForm.funitureType },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "funitureType",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("設置予定のお部屋")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.room,
                                expression: "inputForm.room"
                              }
                            ],
                            attrs: { type: "text", name: "room" },
                            domProps: { value: _vm.inputForm.room },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "room",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("サイズ横幅(W)mm")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.width,
                                expression: "inputForm.width"
                              }
                            ],
                            attrs: { type: "text", name: "width" },
                            domProps: { value: _vm.inputForm.width },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "width",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("サイズ横幅(H)mm")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.height,
                                expression: "inputForm.height"
                              }
                            ],
                            attrs: { type: "text", name: "height" },
                            domProps: { value: _vm.inputForm.height },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "height",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("サイズ横幅(D)mm")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.depth,
                                expression: "inputForm.depth"
                              }
                            ],
                            attrs: { type: "text", name: "depth" },
                            domProps: { value: _vm.inputForm.depth },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "depth",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", [_vm._v("ご希望カラー")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.colorPref,
                                expression: "inputForm.colorPref"
                              }
                            ],
                            attrs: { type: "text", name: "colorPref" },
                            domProps: { value: _vm.inputForm.colorPref },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "colorPref",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form_elements" }, [
                          _c("label", { staticClass: "wide" }, [
                            _vm._v(
                              "具体的な家具のイメージやご相談事項、その他ご要望はごちらにご記入ください。"
                            )
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputForm.comment,
                                expression: "inputForm.comment"
                              }
                            ],
                            attrs: {
                              name: "funitureImage",
                              maxlength: "500",
                              placeholder: "ご要望あれば自由に入力してください"
                            },
                            domProps: { value: _vm.inputForm.comment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.inputForm,
                                  "comment",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "upload_elements" }, [
                          _c("div", [
                            _vm._v(
                              "ご希望の家具に近い写真、手描きスケッチ、家具設置場所の写真や平面図をご添付ください。プラン作成の参考にいたします。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "sketch_list" },
                            [
                              _vm._l(_vm.inputForm.upImgList, function(
                                image,
                                index
                              ) {
                                return _c("li", { key: "upimage-" + index }, [
                                  _c("img", { attrs: { src: image.thumnail } }),
                                  _c("a", {
                                    staticClass: "close_sketch",
                                    on: {
                                      click: function($event) {
                                        _vm.removeImage(index)
                                      }
                                    }
                                  })
                                ])
                              }),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.inputForm.upImgList.length < 10,
                                      expression:
                                        "inputForm.upImgList.length < 10"
                                    }
                                  ],
                                  attrs: { id: "add_sketch" },
                                  on: { click: _vm.onAddSketch }
                                },
                                [
                                  _c(
                                    "a",
                                    { attrs: { href: "javascript:void(0);" } },
                                    [_vm._v("画像を追加")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "newFileRef",
                                    attrs: { type: "file" },
                                    on: { change: _vm.onFileChange }
                                  })
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.errors.maxImg
                            ? _c("div", { staticClass: "error_text2" }, [
                                _vm._v(_vm._s(_vm.errors.maxImg))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(5)
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "elements_checkbox" }, [
                          _c("div", [
                            _vm._v("本サイトをどちらでお知りになりましたか？")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "cb" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.instagram,
                                  expression: "infoSrc.instagram"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_insta" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.instagram)
                                  ? _vm._i(_vm.infoSrc.instagram, null) > -1
                                  : _vm.infoSrc.instagram
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.instagram,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "instagram",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "instagram",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "instagram", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_insta" } }, [
                              _vm._v("instagram")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.internet,
                                  expression: "infoSrc.internet"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_internet" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.internet)
                                  ? _vm._i(_vm.infoSrc.internet, null) > -1
                                  : _vm.infoSrc.internet
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.internet,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "internet",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "internet",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "internet", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_internet" } }, [
                              _vm._v("インターネット検索")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.introduce,
                                  expression: "infoSrc.introduce"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_introduce" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.introduce)
                                  ? _vm._i(_vm.infoSrc.introduce, null) > -1
                                  : _vm.infoSrc.introduce
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.introduce,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "introduce",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "introduce",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "introduce", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_introduce" } }, [
                              _vm._v("ご紹介")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.advert,
                                  expression: "infoSrc.advert"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_advert" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.advert)
                                  ? _vm._i(_vm.infoSrc.advert, null) > -1
                                  : _vm.infoSrc.advert
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.advert,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "advert",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "advert",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "advert", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_advert" } }, [
                              _vm._v("広告")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.infoSrc.other,
                                  expression: "infoSrc.other"
                                }
                              ],
                              attrs: { type: "checkbox", id: "opt_other" },
                              domProps: {
                                checked: Array.isArray(_vm.infoSrc.other)
                                  ? _vm._i(_vm.infoSrc.other, null) > -1
                                  : _vm.infoSrc.other
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.infoSrc.other,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "other",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.infoSrc,
                                          "other",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.infoSrc, "other", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "opt_other" } }, [
                              _vm._v("その他")
                            ])
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestType !== 0
                  ? _c("div", { staticClass: "form_submit" }, [
                      Object.keys(_vm.errors).length > 0
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(
                              "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: { click: _vm.confirm }
                        },
                        [_vm._v("送信内容を確認する")]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        : [
            _c("div", { staticClass: "content_main" }, [
              _c("h1", [_vm._v("アップロード内容の確認")]),
              _vm._v(" "),
              _c("section", { staticClass: "confirm_sec" }, [
                _c("h3", [_vm._v("スケッチ画像")]),
                _vm._v(" "),
                _c("div", { staticClass: "img_list" }, [
                  _c(
                    "ul",
                    { staticClass: "sketch_list" },
                    _vm._l(_vm.inputForm.upImgList, function(image, index) {
                      return _c("li", { key: "upimage-" + index }, [
                        _c("img", { attrs: { src: image.thumnail } })
                      ])
                    })
                  )
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("コメント")]),
                _vm._v(" "),
                _c("div", { attrs: { id: "confirm_comment" } }, [
                  _vm._v(_vm._s(_vm.inputForm.comment))
                ])
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "confirm_sec", attrs: { id: "upload_confirm" } },
                [
                  _c("h3", [_vm._v("入力内容")]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _c("div", [_vm._v("メールアドレス:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.inputForm.email))])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", [_vm._v("氏名:")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.inputForm.lastName) +
                            " " +
                            _vm._s(_vm.inputForm.firstName)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", [_vm._v("氏名（カナ）:")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.inputForm.lastNameKana) +
                            " " +
                            _vm._s(_vm.inputForm.firstNameKana)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", [_vm._v("お届け先の郵便番号:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.inputForm.postcd))])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", [_vm._v("連絡先電話番号:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.inputForm.tel))])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", [_vm._v("設置場所について:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.locationLabel))])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", [_vm._v("エレベーター有り:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.isElevetorFlg))])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "scroll_rule" },
                [_c("dd-userule")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form_submit" }, [
                _c("div", { staticClass: "cb" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.isPricyConsent,
                        expression: "isPricyConsent"
                      }
                    ],
                    attrs: { type: "checkbox", name: "consent" },
                    domProps: {
                      checked: Array.isArray(_vm.isPricyConsent)
                        ? _vm._i(_vm.isPricyConsent, null) > -1
                        : _vm.isPricyConsent
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.isPricyConsent,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.isPricyConsent = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isPricyConsent = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isPricyConsent = $$c
                        }
                      }
                    }
                  }),
                  _vm._v("プライバシーポリシーと利用規約に同意する\n        ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "action_area" }, [
                  _c(
                    "button",
                    { attrs: { type: "button" }, on: { click: _vm.cancel } },
                    [_vm._v("戻る")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class: { disabled: !_vm.isUploadEnable },
                      attrs: { type: "button" },
                      on: { click: _vm.complete }
                    },
                    [_vm._v("アップロード")]
                  )
                ])
              ])
            ])
          ],
      _vm._v(" "),
      _c("div", { staticClass: "bottom_nav" }, [
        _c(
          "div",
          {
            class: { selected: _vm.requestType === 1 },
            on: {
              click: function($event) {
                _vm.onRequestTypeAndJump(1)
              }
            }
          },
          [
            _c("img", {
              staticClass: "img_list",
              attrs: { src: _vm.getImage("common/talk.svg"), alt: "" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("打ち合わせ")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { selected: _vm.requestType === 2 },
            on: {
              click: function($event) {
                _vm.onRequestTypeAndJump(2)
              }
            }
          },
          [
            _c("img", {
              staticClass: "img_list",
              attrs: { src: _vm.getImage("common/file.svg"), alt: "" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("見積もり")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { selected: _vm.requestType === 3 },
            on: {
              click: function($event) {
                _vm.onRequestTypeAndJump(3)
              }
            }
          },
          [
            _c("img", {
              staticClass: "img_list",
              attrs: { src: _vm.getImage("common/pallet.svg"), alt: "" }
            }),
            _vm._v(" "),
            _vm._m(6)
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("p", { staticClass: "new_order" }, [_vm._v("NEW!")]),
      _vm._v("新しいオーダー家具の買い方！")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "service" } }, [
      _c("h3", [_vm._v("私たちの「スケッチオーダー」サービスについて")]),
      _vm._v(" "),
      _c("p", { staticClass: "description" }, [
        _vm._v(
          "\n          私たちは住宅設備（キッチン・収納・建具など）の設計製造データを自動生成するクラウドシステムの開発会社であるドゥーマンズと、製造技術による量的背景と品質に特化した大手木工工場と、匠の技と地域密着型の施工技術に特化した職人集団である東京建具協同組合が提携して立ち上げたジョイントベンチャーです。"
        ),
        _c("br"),
        _vm._v(
          "\n          これまでの各社の技術やノウハウを活かし、最高品質のオーダー家具の製造から設置施工まで全国で対応し、最高の住み心地を提供することを目指しています。"
        ),
        _c("br"),
        _vm._v(
          "\n          この提携により、量的背景を利用したスピードと価格と品質を、また量的背景の真逆である一品造りの匠の技と職人施工技術、そして本来すべてが人工作業である設計図の作成や見積積算及び製造データ作成など膨大な工数を自動生成技術により無くし、省人化と時短を実現したことで、お客様は欲しい収納のスケッチをアップロードするだけで、設計プランナーが図面と見積書でご提案致します。このサービスは提案から製造・設置施工まで全国でご対応します。（2024年度までは首都圏のみでご対応）"
        ),
        _c("br"),
        _vm._v(
          "\n          自分の欲しいサイズで、引出しや扉、色柄素材も自由にそして低価格で家具を作る事ができれば、きっと皆様に喜んで頂ける。これまでは、家具はたくさんの中から「選ぶもの」だったと思います。"
        ),
        _c("br"),
        _vm._v(
          "\n          これからはスケッチを描いて「造るもの」となると思います。"
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n          この「スケッチオーダー」によって、これまで不可能だったオーダー家具の汎用化が実現すると思います。私たちのスケッチオーダーによって、皆様の快適な住み心地に貢献できるよう、職人もエンジニアも設計者も力を合わせて全力で邁進いたします。何卒、お力添え頂けますようお願い申し上げます。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("スケッチ"), _c("br"), _vm._v("オーダー")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "description" }, [
      _vm._v(
        "\n          ①スケッチができたら、スマホで写真を撮りライブラリに保存"
      ),
      _c("br"),
      _vm._v(
        "\n          ②【画像を追加】ボタンからライブラリを選択し保存した写真を選ぶ"
      ),
      _c("br"),
      _vm._v("\n          ③アップロード"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n          アップロードされたスケッチは直ちに設計プランナーまで届きます。"
      ),
      _c("br"),
      _vm._v("\n          担当設計者が決まりプランニングが開始されます。"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n          スケッチやご要望についての確認のため、担当設計者から電話等でお問い合わせさせていいただく場合は、お気軽に何なりとご要望などお伝えください。"
      ),
      _c("br"),
      _vm._v(
        "\n          家具の設計が完了しだい、担当設計者からご連絡させていただき、打ち合わせと設置場所の採寸調査となります。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "notes" }, [
      _vm._v("\n          ※スケッチ(画像)は10枚まで追加できます"),
      _c("br"),
      _vm._v("\n          ※対応ファイル形式:jpg、png、gif、heic"),
      _c("br"),
      _vm._v("\n          ※動画はアップロードできません\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "notes" }, [
      _vm._v("\n            ※スケッチ(画像)は10枚まで追加できます"),
      _c("br"),
      _vm._v("\n            ※対応ファイル形式:jpg、png、gif、heic"),
      _c("br"),
      _vm._v("\n            ※動画はアップロードできません\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("スケッチ"), _c("br"), _vm._v("オーダー")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2014f9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2014f9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/Top.vue
// module id = null
// module chunks = 